import { Box, IconButton, Modal, Typography } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import closeIcon from '../../../assets/Admin/RequestImages/close-icon.svg';
import './ForgotPasswordModal.css';
import { useState } from 'react';

import { toast } from 'react-hot-toast';
import { axiosInstance } from '../../../utils/tokenUtils';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

const ForgotPasswordModal = ({ setOpenPasswordModal, open, onClose }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmNewPassword] = useState('');
  const [passwordError, setPasswordError] = useState(null);

  const password_validate = password => {
    const re = {
      capital: /(?=.*[A-Z])/,
      length: /.{8,40}/,
      specialChar: /[ -/:-@[-`{-~]/,
      digit: /(?=.*[0-9])/,
    };

    if (!re.length.test(password)) {
      return `Password must be at least 8 characters long`;
    }
    if (!re.capital.test(password)) {
      return 'Password must include at least one uppercase letter';
    }
    if (!re.specialChar.test(password)) {
      return 'Password must include at least one special character';
    }
    if (!re.digit.test(password)) {
      return 'Password must include at least one digit';
    }

    return null;
  };

  const togglePasswordVisibility = field => {
    switch (field) {
      case 'current':
        setShowPassword(!showPassword);
        break;
      case 'new':
        setShowNewPassword(!showNewPassword);
        break;
      case 'confirm':
        setShowConfirmPassword(!showConfirmPassword);
        break;
      default:
        break;
    }
  };
  const handleClose = () => {
    setOpenPasswordModal(false);
  };

  const handleUserNewPasswordChange = e => {
    setNewPassword(e.target.value);
    setPasswordError(null);
  };

  const handleUserConfirmNewPasswordChange = e => {
    setConfirmNewPassword(e.target.value);
    setPasswordError(null);
  };

  const handleNewPasswordBlur = () => {
    if (newPassword) {
      const passwordValidationError = password_validate(newPassword);
      if (passwordValidationError) {
        setPasswordError(passwordValidationError);
      }
    }
  };

  const handleSave = async e => {
    e.preventDefault();

    const passwordValidationError = password_validate(newPassword);

    if (passwordValidationError) {
      setPasswordError(passwordValidationError);
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error('Passwords do not match!');
      return;
    }

    try {
      const response = await axiosInstance.post(`/auth/change-password`, {
        current_password: currentPassword,
        new_password: newPassword,
      });
      if (response.status === 200) {
        setOpenPasswordModal(false);
        toast.success(`Password changed successfully!`);
      }
    } catch (error) {
      console.error('Error changing password:', error);
      toast.error('Failed to change password. Please try again.');
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Box className="password-modal-container">
          <Box className="password-modal-header">
            <Typography className="modal-title">Change Password</Typography>
            <IconButton onClick={handleClose}>
              <img src={closeIcon || '/placeholder.svg'} alt="close" />
            </IconButton>
          </Box>

          <Box className="password-modal-body">
            <div className="password-form-group">
              <label className="password-label">Current Password</label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="password-input"
                  placeholder="Enter current password"
                  value={currentPassword}
                  onChange={e => setCurrentPassword(e.target.value)}
                />
                <button
                  onClick={() => togglePasswordVisibility('current')}
                  className="visibility-toggle"
                >
                  {showPassword ? (
                    <VisibilityOff style={{ color: '#949DA6' }} />
                  ) : (
                    <Visibility style={{ color: '#949DA6' }} />
                  )}
                </button>
              </div>
            </div>

            <div className="password-form-group">
              <label className="password-label">New Password</label>
              <div className="password-input-wrapper">
                <input
                  type={showNewPassword ? 'text' : 'password'}
                  className="password-input"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={handleUserNewPasswordChange}
                  onBlur={handleNewPasswordBlur}
                />
                <button
                  onClick={() => togglePasswordVisibility('new')}
                  className="visibility-toggle"
                >
                  {showNewPassword ? (
                    <VisibilityOff style={{ color: '#949DA6' }} />
                  ) : (
                    <Visibility style={{ color: '#949DA6' }} />
                  )}
                </button>
              </div>
            </div>

            <div className="password-form-group">
              <label className="password-label">Confirm Password</label>
              <div className="password-input-wrapper">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  className="password-input"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  // onChange={(e) => setConfirmPassword(e.target.value)}
                  onChange={handleUserConfirmNewPasswordChange}
                />
                <button
                  onClick={() => togglePasswordVisibility('confirm')}
                  className="visibility-toggle"
                >
                  {showConfirmPassword ? (
                    <VisibilityOff style={{ color: '#949DA6' }} />
                  ) : (
                    <Visibility style={{ color: '#949DA6' }} />
                  )}
                </button>
              </div>
            </div>

            {passwordError && (
              <div style={{ color: 'red', fontSize: '13px', marginTop: '10px' }}>
                {passwordError}
              </div>
            )}
          </Box>

          <Box className="password-modal-footer">
            <button className="cancel-button" onClick={handleClose}>
              Cancel
            </button>
            <button className="save-button" onClick={handleSave}>
              Save
            </button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ForgotPasswordModal;
